module.exports = __webpack_public_path__ + "assets/img/favicon/favicon-32x32.40111cb3853dc87e9a3363311ce9670a.png";